import { Component, ErrorHandler, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

import { Airport } from '../models/airport.model';
import { HistoryTrackerService } from '../../shared/history-tracker/history-tracker.service';
import { environment } from '../../../environments/environment';
import { storageAvailable } from '../../util/helpers';
import { MatCheckboxChange } from '@angular/material';
import { PinSearchbarService } from '../../shared/services/pin-searchbar.service';


@Component({
  selector: 'app-airport-page',
  templateUrl: './airport-page.component.html',
  styleUrls: ['./airport-page.component.scss']
})
export class AirportPageComponent implements OnInit {
  activeChildComponent: any;
  airport: Airport;
  isPinChecked = false;
  navLinks: any[] = [{
    label: 'Airport Details',
    icon: 'info',
    params: ['details']
  }, {
    label: 'Local Activities',
    icon: 'location_on',
    params: ['activities']
  }];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _meta: Meta,
    private _title: Title,
    private _history: HistoryTrackerService,
    private _errorHandler: ErrorHandler,
    private _pinSearchbarService: PinSearchbarService
  ) { }

  ngOnInit() {
    if (storageAvailable('localStorage')) {
      const storageVal = localStorage.getItem('searchbarPinned');
      this.isPinChecked = storageVal === 'true';
    }
    this._route.data
      .subscribe((data: { airport: Airport }) => {
        const airport = data.airport;
        this.airport = airport;
        this._updateMeta(airport);
        if (storageAvailable('sessionStorage')) {
          sessionStorage.setItem('lastAirport', airport.identifier);
          // Viewing an airport makes it the fresh "back" target for any flying club opened from here, so
          // clear any stale Flying Club Finder return URL (see FlyingclubPageComponent.goBack).
          sessionStorage.removeItem('flyingClubSearchReturn');
        }
        if (this.activeChildComponent) {
          this.activeChildComponent.airport = airport;
        }
      }, (error: any) => {
        this._errorHandler.handleError(error);
      });
  }

  private _updateMeta(airport: Airport) {
    this._title.setTitle(`${airport.name} - ${airport.identifier} - ${environment.appName}`);
    this._meta.updateTag({
      name: 'description',
      content: `FAA aeronautical and local business information for airport ${airport.name} (${airport.identifier}), `
        + `${airport.stateProvince}, ${airport.country}, covering airport operations, communications, weather, `
        + `runways, comments and remarks, approach plates and procedures, services, all reporting businesses and `
        + `FBOs, and kneeboard print outs.`
    });
  }

  onRouterOutletActivate(component) {
    this.activeChildComponent = component;
    component.airport = this.airport;
  }

  cameFromSearch(): boolean {
    return (this._history.previousUrl && this._history.previousUrl.startsWith('/search'));
  }

  onClickBack (event: MouseEvent) {
    event.preventDefault();
    if (this._history.previousUrl && this._history.previousUrl.startsWith('/search')) {
      this._router.navigateByUrl(this._history.previousUrl);
      return;
    }
    this._router.navigate(['/search'], { queryParams: { 'public': 1 } });
  }

  onClickNewSearch (event: MouseEvent) {
    event.preventDefault();
    this._router.navigate(['/']);
  }

  onChange (ob: MatCheckboxChange) {
    this.isPinChecked = ob.checked;
    if (storageAvailable('localStorage')) {
      localStorage.setItem('searchbarPinned', '' + this.isPinChecked);
    }
    this._pinSearchbarService.pinSearchbarClicked(this.isPinChecked);
  }
}
